import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

// Assets
import userProfileStyles from "./userProfileStyles.jsx"

// Services
import {deviceService} from '_services'
import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";

import {Alert} from "@mui/material";
import Button from "../../components/CustomButtons";
import {connect} from "react-redux";
import {alertActions, sweetAlertActions, deviceFleetActions} from "../../_actions";
import Table from "../../components/Table";
import { beautify_name} from "../helpers";

import {getUserId} from "../../_services/authenticate";
import DeviceDropdown from "../helper_functions/DeviceDropdown.jsx"
import { string } from "prop-types"


class DeviceCommands extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      available_maps: {},
      // TODO: need to figure out if the user is in control.
      // in_control = state.state.controller === getUserId()
      in_control: true,
    }
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    this.refresh()
  }

  componentWillUnmount() {
    this._is_mounted = false
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.device_serial !== this.props.device_serial) {
      this.refresh()
    }
  }

  refresh() {
    const {device_serial} = this.props

    deviceService.getDeviceMapData(device_serial, res => {
      this.setState({
        last_map_refresh: res.time,
        available_maps: res.available_maps,
      })
    })
  }

  stop_immediately() {
    const {device_serial, dispatch} = this.props
    deviceService.stopImmediately(device_serial, res => {
      dispatch(sweetAlertActions.clear())
      dispatch(alertActions.success("The command is sent to the device"))
    })
  }


  clear_popup() {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clear())
  }

  confirm_stop_immediately() {
    const {dispatch} = this.props
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.stop_immediately.bind(this),
      confirmBtnText: "Yes",
      content: ''
    }))
  }

  confirm_upload_all_incident_data() {
    const {dispatch} = this.props
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.upload_all_incident_data.bind(this),
      confirmBtnText: "Yes",
      content: ''
    }))

  }

  upload_all_incident_data() {
    const {device_serial, dispatch} = this.props
    deviceService.uploadAllIncidentData(device_serial, res => {
      dispatch(sweetAlertActions.clear())
      dispatch(alertActions.success("The command is sent to the device"))
    })

  }

  confirm_validate_maps() {
    const {dispatch} = this.props
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.validate_maps.bind(this),
      confirmBtnText: "Yes",
      content: ''
    }))

  }

  validate_maps() {
    const {device_serial, dispatch} = this.props
    deviceService.validateMaps(device_serial, res => {
      dispatch(sweetAlertActions.clear())
      dispatch(alertActions.success("The command is sent to the device"))
    })
  }

  take_control() {
    const {device_serial, dispatch} = this.props

    deviceService.waitOnEvent(device_serial, "control", res => {
    })

    deviceService.takeControl(device_serial, res => {
      setTimeout(() => dispatch(deviceFleetActions.fetchDeviceStateV2(device_serial)), 1000)
    })
  }

  release_control() {
    const {device_serial, dispatch} = this.props
    deviceService.releaseControl(device_serial, res => {
      setTimeout(() => dispatch(deviceFleetActions.fetchDeviceStateV2(device_serial)), 1000)
    })
  }

  render() {
    const {device_name, is_live, current_state} = this.props
    const {available_maps, in_control} = this.state

    let all_maps_valid = true
    Object.keys(available_maps).forEach(map_id => {
      let map = available_maps[map_id]
      if (!map["valid"]) {
        all_maps_valid = false
      }
    })

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader><h4 style={{color: primaryColor}}><b>Device Commands - {device_name}</b></h4>
              <DeviceDropdown allowed_device_types={["XENION_CONNECT", "XENION_A6", "LUMION_FIX"]}/>

              <GridItem xs={12} md={4}>
                <Button color={"transparent"} onClick={this.take_control.bind(this)}> Request
                  Control </Button>
                <Button color={"transparent"} onClick={this.release_control.bind(this)}> Release
                  Control </Button>
              </GridItem>
              </CardHeader>
              <CardBody>
                {!is_live && <Alert severity={"warning"}>You cannot execute commands, the device is not online </Alert>}
                {/* {is_live && !in_control &&
                  <Alert severity={"warning"}>Not all commands are available, you are not in control of the
                    device </Alert>} */}

                {is_live &&
                  <div>
                    <Alert severity={"success"}> You can execute commands. Mind the device state, it
                      is: <b>{current_state}</b></Alert>
                      <Alert severity={"warning"}>Right now, we cannot know if you are in control of the device. Keep this in mind when executing commands.</Alert>
                    <br/>
                    <Table
                      tableHeaderColor="primary"
                      style={{fontSize: '10px'}}
                      tableData={[
                        [
                          <p>Stop the action the device is doing</p>,
                          <Button color={'danger'} onClick={this.confirm_stop_immediately.bind(this)}>Stop
                            Immediately</Button>,
                          <p> Current State: <b>{current_state}</b></p>
                        ],
                        [
                          <p>Upload all the incident data, the device must be in idle. You can click on stop immediately
                            to make this happen<br/>
                            This upload will only work when the device is connected to WiFi. To force update through 4G,
                            upload the logs individually
                          </p>,
                          <Button color={'primary'} onClick={this.confirm_upload_all_incident_data.bind(this)}>Upload
                            All</Button>,
                          ""
                        ],
                        [
                          <p>Ask the device to validate all maps it has downloaded</p>,
                          <Button color={'primary'} onClick={this.confirm_validate_maps.bind(this)}>Validate
                            Maps</Button>,
                          <p> All Maps Valid: <b>{all_maps_valid === null ? "-" : all_maps_valid ? "Yes" : "No"}</b></p>
                        ],
                        ["", "", ""]
                      ]}
                    />


                  </div>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const {device_serial, all_devices, device_state_v2} = state.device_fleet
  let device_name = ""
  all_devices.forEach((device) => {
    if (device["serial"] === device_serial) {
      device_name = device["name"]
    }
  })

  const device_state = device_state_v2[device_serial]

  return {
    device_serial,
    device_name,
    is_live: device_state ? device_state.is_live : false,
    current_state: device_state ? beautify_name(device_state.state) : "no state"
  }
}

export default connect(mapStateToProps)(withStyles(userProfileStyles)(DeviceCommands))
